export const DIALOG_CSS_CLASSES = {
  DIALOG_ROOT: "dialog",
  DIALOG_CLOSE_BUTTON: "dialog-close-button",
  DIALOG_HEADER: "dialog-header",
  DIALOG_BODY: "dialog-body",
  DIALOG_ACTIONS_WRAPPER: "dialog-actions-wrapper",
  DIALOG_ACTIONS: "dialog-actions",
  DIALOG_OVERLAY: "dialog-overlay",
};
